import React from 'react';
import FileSearch from 'lucide-react/dist/esm/icons/file-search';
import BarChart3 from 'lucide-react/dist/esm/icons/bar-chart-3';
import Shield from 'lucide-react/dist/esm/icons/shield';

interface ModuleBadgesProps {
  modules: string[];
  size?: 'sm' | 'md';
}

const MODULE_CONFIG: Record<string, {
  icon: React.FC<{ size: number; className?: string }>;
  label: string;
  colors: string;
}> = {
  'financial-forensics': {
    icon: FileSearch,
    label: 'Financial Forensics',
    colors: 'text-blue-400 bg-blue-400/10 border-blue-400/20',
  },
  performance: {
    icon: BarChart3,
    label: 'Performance',
    colors: 'text-emerald-400 bg-emerald-400/10 border-emerald-400/20',
  },
  aml: {
    icon: Shield,
    label: 'AML',
    colors: 'text-amber-400 bg-amber-400/10 border-amber-400/20',
  },
};

const SIZES = {
  sm: { badge: 'h-6 w-6', icon: 12 },
  md: { badge: 'h-7 w-7', icon: 14 },
} as const;

const ModuleBadges: React.FC<ModuleBadgesProps> = ({ modules, size = 'sm' }) => {
  const { badge, icon } = SIZES[size];

  return (
    <div className="flex gap-1">
      {modules.map((mod) => {
        const config = MODULE_CONFIG[mod];
        if (!config) return null;
        const Icon = config.icon;
        return (
          <span
            key={mod}
            title={config.label}
            className={`inline-flex items-center justify-center rounded-lg border ${badge} ${config.colors}`}
          >
            <Icon size={icon} />
          </span>
        );
      })}
    </div>
  );
};

export default React.memo(ModuleBadges);
